export default __webpack_public_path__ + "static/media/1.d4a40703.jpg";